<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="patientnew">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="cyan darken-2">
                        <v-toolbar-title>
                            <v-icon>mdi-account-plus</v-icon>&nbsp; Nuevo Paciente&nbsp;&nbsp;
                        </v-toolbar-title>

                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onCancel" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cancelar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-divider></v-divider>
                                <v-list-item @click="onCancel">
                                    <v-list-item-title>
                                        <v-icon color="red" @click="onCancel">mdi-close</v-icon>&nbsp; Cancelar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para los campos del nuevo paciente: -->
                    <v-container pa-2 grid-list-sm fluid>
                        <!-- Renglón único para toda la información del nuevo paciente: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Info de Nuevo Paciente: *********************** -->
                            <v-flex xs12>
                                <v-card class="grey lighten-4">
                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="cyan--text text--darken-3 caption"
                                                        >Identificación</span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs12 md3>
                                                    <v-text-field
                                                        label="CURP"
                                                        v-model="patient.curp"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-text-field
                                                        label="Apellido paterno"
                                                        v-model="patient.lastName1"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-text-field
                                                        label="Apellido materno"
                                                        v-model="patient.lastName2"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-text-field
                                                        label="Nombre"
                                                        v-model="patient.name"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-text-field
                                                        label="Pseudónimo"
                                                        v-model="patient.pseudonym"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs12 md2>
                                                    <v-select
                                                        label="Sexo"
                                                        v-model="patient.sex"
                                                        color="cyan darken-3"
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-select
                                                        label="Estado Civil"
                                                        v-model="patient.civilState"
                                                        color="cyan darken-3"
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-text-field
                                                        label="Apellido de casada"
                                                        v-model="patient.spouseLastName"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-menu
                                                        v-model="bMenuBirthDay"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{on}">
                                                            <v-text-field
                                                                :dense="bDense"
                                                                color="cyan darken-3"
                                                                v-model="patient.birthDay"
                                                                label="Fecha de nacimiento"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            color="cyan darken-3"
                                                            v-model="patient.birthDay"
                                                            @input="bMenuBirthDay = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>

                                                <v-flex xs12 sm4 md3>
                                                    <v-text-field
                                                        label="Edad"
                                                        v-model="age"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs12 md3>
                                                    <v-text-field
                                                        label="Nacionalidad"
                                                        v-model="patient.citizenship"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md2>
                                                    <v-text-field
                                                        label="Religión"
                                                        v-model="patient.religion"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md3>
                                                    <v-text-field
                                                        label="Ocupación"
                                                        v-model="patient.ocupation"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm4 md3>
                                                    <v-text-field
                                                        label="Escolaridad"
                                                        v-model="patient.education"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider></v-divider>

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="cyan--text text--darken-3 caption"
                                                        >Historia Clínica</span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.notes"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Notas"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.familyHistory"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Antecedentes heredo-familiares"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.pathologicalHistory"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Antecedentes personales patológicos"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.nonPathologicalHistory"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Antecedentes personales no patológicos"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.allergies"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Alergias"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.gynecoObstetricHistory"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Antecedentes Gineco-Obstétricos"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.activeDx"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Diagnósticos activos"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        v-model="patient.activeTx"
                                                        :auto-grow="true"
                                                        color="cyan darken-3"
                                                        label="Tratamientos activos"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout align-center justify-start row fill-height>
                                                <v-flex xs6 sm4 md3>
                                                    <v-select
                                                        label="Tipo de Sangre"
                                                        v-model="patient.bloodTypeID"
                                                        color="cyan darken-3"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider></v-divider>

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="cyan--text text--darken-3 caption"
                                                        >Información Complementaria</span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout align-center justify-start row>
                                                <v-flex xs12 sm6>
                                                    <v-container grid-list-xs fluid>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 md6>
                                                                <v-checkbox
                                                                    dense
                                                                    label="Discapacidad motriz"
                                                                    v-model="patient.motorDisability"
                                                                    color="orange accent-4"
                                                                ></v-checkbox>
                                                            </v-flex>

                                                            <v-flex xs12 md6>
                                                                <v-checkbox
                                                                    dense
                                                                    label="Discapacidad mental"
                                                                    v-model="patient.mentalDisability"
                                                                    color="orange accent-4"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 md6>
                                                                <v-checkbox
                                                                    dense
                                                                    label="Discapacidad visual"
                                                                    v-model="patient.visualDisability"
                                                                    color="orange accent-4"
                                                                ></v-checkbox>
                                                            </v-flex>

                                                            <v-flex xs12 md6>
                                                                <v-checkbox
                                                                    dense
                                                                    label="Discapacidad auditiva"
                                                                    v-model="patient.hearingImpairment"
                                                                    color="orange accent-4"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <v-textarea
                                                                    dense
                                                                    v-model="patient.otherDisability"
                                                                    :auto-grow="true"
                                                                    color="cyan darken-3"
                                                                    label="Otra discapacidad"
                                                                    rows="3"
                                                                ></v-textarea>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-container fluid>
                                                        <v-layout row align-start>
                                                            <v-flex xs12>
                                                                <v-text-field
                                                                    label="Seguridad social"
                                                                    v-model="patient.socialSecurity"
                                                                    color="cyan darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <v-text-field
                                                                    label="Seguridad privada"
                                                                    v-model="patient.privateSecurity"
                                                                    color="cyan darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <v-text-field
                                                                    label="Referido por:"
                                                                    v-model="patient.referedFrom"
                                                                    color="cyan darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider></v-divider>

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="cyan--text text--darken-3 caption"
                                                        >Dirección e información de contacto</span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs9 sm9 md4>
                                                    <v-text-field
                                                        label="Calle"
                                                        v-model="patient.address.street"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs3 sm2 md2>
                                                    <v-text-field
                                                        label="Número"
                                                        v-model="patient.address.number"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs11 sm6 md3>
                                                    <v-text-field
                                                        label="Colonia"
                                                        v-model="patient.address.colonia"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs8 sm6 md2>
                                                    <v-text-field
                                                        label="C.P."
                                                        v-model="patient.address.cp"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs9 sm9 md4>
                                                    <v-text-field
                                                        label="Municipio"
                                                        v-model="patient.address.municipio"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm9 md4>
                                                    <v-text-field
                                                        label="Estado"
                                                        v-model="patient.address.state"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm9 md4>
                                                    <v-text-field
                                                        label="Colonia"
                                                        v-model="patient.address.country"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs9 sm6 md3>
                                                    <v-text-field
                                                        label="Teléfono 1"
                                                        v-model="patient.address.phone1"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm6 md3>
                                                    <v-text-field
                                                        label="Teléfono 2"
                                                        v-model="patient.address.phone2"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm6 md3>
                                                    <v-text-field
                                                        label="Celular"
                                                        v-model="patient.address.mobile"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm6 md3>
                                                    <v-text-field
                                                        label="Correo electrónico"
                                                        v-model="patient.address.email"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="cyan--text text--darken-3 caption"
                                                        >Familiares de contacto / Responsables</span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs9 sm9 md2>
                                                    <v-text-field
                                                        label="Apellido paterno"
                                                        v-model="patient.family[0].lastName1"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm9 md2>
                                                    <v-text-field
                                                        label="Apellido materno"
                                                        v-model="patient.family[0].lastName2"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm9 md2>
                                                    <v-text-field
                                                        label="Nombre"
                                                        v-model="patient.family[0].name"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm9 md2>
                                                    <v-text-field
                                                        label="Teléfono"
                                                        v-model="patient.family[0].phone"
                                                        color="cyan darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs9 sm9 md3>
                                                    <v-select
                                                        label="Relación con el paciente"
                                                        v-model="patient.family[0].relationship"
                                                        color="cyan darken-3"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout align-center justify-end row fill-height>
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info del nuevo paciente *********************** -->
                        </v-layout>

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Termina renglón único para la información del nuevo paciente -->
                    </v-container>
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'newPatient',
    data() {
        return {
            drawer: false,

            bDense: false,

            bInvalidData: false,
            errorMessage: '',

            bMenuBirthDay: false,
            age: '',

            patient: {
                curp: '',
                lastName1: '',
                lastName2: '',
                name: '',
                pseudonym: '',
                sex: 0,
                civilState: 0,
                spouseLastName: '',
                birthDay: '',
                citizenship: '',
                religion: '',
                ocupation: '',
                education: '',
                notes: '',
                familyHistory: '',
                pathologicalHistory: '',
                nonPathologicalHistory: '',
                allergies: '',
                gynecoObstetricHistory: '',
                activeDx: '',
                activeTx: '',
                bloodTypeID: 1,
                organDonor: true,
                socialSecurity: '',
                privateSecurity: '',
                referedFrom: '',
                visualDisability: false,
                hearingImpairment: false,
                mentalDisability: false,
                motorDisability: false,
                otherDisability: '',
                address: {
                    street: '',
                    number: '',
                    colonia: '',
                    cp: '',
                    municipio: '',
                    state: '',
                    country: ''
                },
                phone1: '',
                phone2: '',
                mobile: '',
                email: '',
                family: [
                    {
                        lastName1: '',
                        lastName2: '',
                        name: '',
                        phone: '',
                        relationship: ''
                    },
                    {
                        lastName1: '',
                        lastName2: '',
                        name: '',
                        phone: '',
                        relationship: ''
                    },
                    {
                        lastName1: '',
                        lastName2: '',
                        name: '',
                        phone: '',
                        relationship: ''
                    }
                ]
            }
        };
    },
    created() {},
    methods: {
        onCancel() {
            this.$router.push('/');
        },

        onSave() {
            var bDataOK = false;

            //Validación de los datos:

            //PENDIENTE...

            if (bDataOK) {
                this.bEdit = false;
            }
        }
    },
    computed: {
        ...mapGetters(['waitCursor']),

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.patientnew {
    background: url('../assets/background1.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>